import React, { useState, useEffect } from 'react';
import { IoClose, IoDocumentText, IoDownload } from 'react-icons/io5';
import { useTranslation } from '../../../shared/i18n';
import { 
  BackgroundWrapper, 
  AnimatedTitle, 
  AnimatedCategoryCard,
  PageContainer,
  PageTransition 
} from '../components';
import sabiduria from '../../../assets/conectados/sabiduria.png';
import alianza from '../../../assets/conectados/alianza.png';
import comoJugar from '../../../assets/conectados/como-jugar.png';
import instruccionesPDF from '../../../assets/conectados/instrucciones.pdf';
import * as S from './ConectadosPage.styles';

// Category data with images
const categoryCards = [
  {
    id: 'sabiduria',
    path: '/conectados/sabiduria',
    image: sabiduria,
  },
  {
    id: 'alianza', 
    path: '/conectados/alianza',
    image: alianza,
  }
];

function ConectadosPage() {
  const t = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
        || window.innerWidth < 768;
      setIsMobile(mobile);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    // Close modal when clicking on the overlay (not the content)
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  const handleOpenPDF = () => {
    window.open(instruccionesPDF, '_blank');
  };

  const handleDownloadPDF = () => {
    const link = document.createElement('a');
    link.href = instruccionesPDF;
    link.download = 'Instrucciones-Como-Jugar.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <BackgroundWrapper>
      <PageContainer>
        <AnimatedTitle />
        
        <PageTransition>
          <S.CategoriesGrid>
            {categoryCards.map((category, index) => (
              <AnimatedCategoryCard 
                key={category.id} 
                to={category.path}
                image={category.image}
                alt={t(`conectados.categories.${category.id}.alt`)}
                delay={index * 0.15}
              />
            ))}
          </S.CategoriesGrid>

          <S.Footer>
            <S.FooterQuote>
              {t('conectados.footer.quote')}
            </S.FooterQuote>
            <S.FooterReference>
              {t('conectados.footer.reference')}
            </S.FooterReference>
          </S.Footer>
        </PageTransition>
      </PageContainer>
      
      <S.FloatingButton 
        onClick={handleOpenModal}
        aria-label={t('conectados.pdfModal.title')}
        title={t('conectados.pdfModal.title')}
      >
        <img src={comoJugar} alt={t('conectados.pdfModal.title')} />
      </S.FloatingButton>

      {isModalOpen && (
        <S.ModalOverlay onClick={handleOverlayClick}>
          <S.ModalContent>
            <S.ModalHeader>
              <h2>{t('conectados.pdfModal.title')}</h2>
              <S.CloseButton 
                onClick={handleCloseModal} 
                aria-label={t('common.close')}
                title={t('common.close')}
              >
                <IoClose />
              </S.CloseButton>
            </S.ModalHeader>
            {isMobile ? (
              <S.MobileMessageContainer>
                <S.MobileIcon>
                  <IoDocumentText />
                </S.MobileIcon>
                <S.MobileTitle>{t('conectados.pdfModal.mobileTitle')}</S.MobileTitle>
                <S.MobileDescription>
                  {t('conectados.pdfModal.mobileDescription')}
                </S.MobileDescription>
                <S.ButtonGroup>
                  <S.ActionButton onClick={handleOpenPDF} primary>
                    <IoDocumentText />
                    <span>{t('conectados.pdfModal.openPDF')}</span>
                  </S.ActionButton>
                  <S.ActionButton onClick={handleDownloadPDF}>
                    <IoDownload />
                    <span>{t('conectados.pdfModal.downloadPDF')}</span>
                  </S.ActionButton>
                </S.ButtonGroup>
              </S.MobileMessageContainer>
            ) : (
              <S.PDFContainer>
                <iframe 
                  src={instruccionesPDF}
                  title={t('conectados.pdfModal.title')}
                />
              </S.PDFContainer>
            )}
          </S.ModalContent>
        </S.ModalOverlay>
      )}
    </BackgroundWrapper>
  );
}

export default ConectadosPage; 